import { tWithKeyAttr as t } from "../../../i18nHelper";
import styles from "./questionReportCommentsPopup.module.css";
import { useGetCommentsToRequestMutation } from "../../../services/api/user.api";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../services/hooks";
import Modal from "../modal/Modal";
import ErrorPopup from "../errorPopup/errorPopup";
import { getPrintDate, getTimeFromTimestamp } from "../../../utils/utils";
import Loader from "../../loader/loader";
import { noDataLabel } from "../../../utils/constants";
import { questionReportCommentsSelector } from "../../../services/selectors/users.selectors";
import useMediaQuery from "../../../hooks/useMediaQuery";

function QuestionReportCommentsPopup({
  usersGuid,
  questionnaireId,
  questionnaireCompaniesId,
  cycle,
}: {
  usersGuid: string;
  questionnaireId: number | string;
  questionnaireCompaniesId: number | string;
  cycle: number | string;
}) {
  const mobile = useMediaQuery("(max-width: 1000px)");

  const questionReportComments = useAppSelector(questionReportCommentsSelector);

  const [openModalError, setOpenModalError] = useState(false);

  const [getUpdates, { status }] = useGetCommentsToRequestMutation();

  useEffect(() => {
    getUpdates({
      id: "0",
      usersGuid: usersGuid,
      questionnaireId,
      questionnaireCompaniesId,
      cycle,
      comment: "",
    }).catch(() => {
      setOpenModalError(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <article className={styles.popup}>
      <h3 className={`title`}>{t('COMMENTS')}</h3>
      {status !== "fulfilled" ? (
        <Loader />
      ) : questionReportComments.length > 0 ? (
        <>
          <ul className={`list`}>
            <li className={`${styles.listRow} ${styles.listRow_header}`}>
              <p className={`listCell`}>{t('NUMBER_1')}</p>
              <p className={`listCell`}>{t('DATE')}</p>
              <p className={`listCell`}>{t('HOUR')}</p>
              <p className={`listCell`}>{t('UPDATED_BY:')}</p>
              {!mobile && <p className={`listCell`}>{t('UPDATE')}</p>}
            </li>
            {questionReportComments.map((c, index) => (
              <li
                key={c.questionnaireAnswerComments.id}
                className={`${styles.listRow} ${
                  mobile && index % 2 !== 0 && "colored"
                }`}
              >
                <p className={`listCell`}>
                  {c?.questionnaireAnswerComments?.id || ""}
                </p>
                <p className={`listCell`}>
                  {c?.questionnaireAnswerComments.createOn
                    ? getPrintDate(
                        new Date(c?.questionnaireAnswerComments.createOn)
                      )
                    : t(noDataLabel)}
                </p>
                <p className={`listCell`}>
                  {c?.questionnaireAnswerComments?.createOn
                    ? getTimeFromTimestamp(
                        new Date(c?.questionnaireAnswerComments?.createOn)
                      )
                    : t(noDataLabel)}
                </p>
                <p className={`listCell`}>{c?.therapistName || ""}</p>
                <p className={`listCell ${styles.fullWidth}`}>
                  {c?.questionnaireAnswerComments?.comment
                    ?.split("\n")
                    .map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    )) || ""}
                  {/*{c?.questionnaireAnswerComments?.comment || ""}*/}
                </p>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <p className={"text"}>{t('NO_NOTES_YET')}</p>
      )}
      {openModalError && (
        <Modal onClose={() => setOpenModalError(false)}>
          <ErrorPopup onClose={() => setOpenModalError(false)} />
        </Modal>
      )}
    </article>
  );
}
export default QuestionReportCommentsPopup;
